/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 *
 **/

import { map, get } from "lodash";

const packageJson = require("../../package.json");

export default function useMenus(modules,t) {
  
  return {
    navbarTopRight: [],
    navbarTopLeft: [],
    navbarSideLeft: [
      {
        to: "/home",
        label: t("OVERVIEW"),
        icon: "box",
        iconcolor: "",
        target: "",
        rbac: ["Admin", "Super Admin", "User"],
        childNavbar: [
          {
            to: "/home",
            label: t("HOME"),
            icon: "home",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin", "User"],
          },
          ...map(modules, (module) => {
            return {
              to: "/dashboard/" + get(module, "id", "46") + "?legend=0",
              label: get(module, "module_name", "-"),
              icon: get(module, "icon", "ban"),
              iconcolor: "",
              target: "",
              isModule: true,
              rbac: ["Admin", "Super Admin", "User"],
              color: get(module, "color"),
              moduleId: module.id,
              org_code: module.org_code
            };
          }),
        ],
      },
      {
        to: "/org",
        label: t("SETTINGS"),
        icon: "cog",
        iconcolor: "",
        target: "",
        rbac: ["Admin", "Super Admin"],
        childNavbar: [
          {
            to: "/org",
            label: t("FACILITIES"),
            icon: "building",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/modules",
            label: t("MODULES"),
            icon: "box",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/metrics",
            label: t("METRICS"),
            icon: "chart-bar",
            iconcolor: "",
            target: "",
            rbac: ["Super Admin"],
          },
          {
            to: "/actions",
            label: t("ACTIONS"),
            icon: "forward",
            iconcolor: "",
            target: "",
            rbac: ["Super Admin"],
          },
          {
            to: "/users",
            label: t("USERS"),
            icon: "users",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/events",
            label: t("EVENTS"),
            icon: "calendar",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/settings",
            label: t("SETTINGS"),
            icon: "cog",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/api/ingestion",
            label: "API",
            icon: "link",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            to: "/license",
            label: t("LICENSE"),
            icon: "key",
            iconcolor: "",
            target: "",
            rbac: ["Admin", "Super Admin"],
          },
          {
            label: t("VERSION")+` : ${packageJson.version}`,
            rbac: ["Admin", "Super Admin"],
            style: { position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)', fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }
          }
        ],
      },
      {
        to: "/",
        label: t("LOG_OUT"),
        icon: "sign-out",
        iconcolor: "",
        target: "",
        rbac: ["Admin", "Super Admin", "User"],
        childNavbar: [],
      },
      {
        to: "/account",
        label: t("MY_ACCOUNT"),
        icon: "user",
        iconcolor: "",
        target: "",
        rbac: ["Admin", "Super Admin", "User"],
        childNavbar: [],
      },
    ],
    exportFormats: {
      print: {
        label: "Print",
        icon: "pi pi-print",
        type: "print",
        ext: "",
      },
      pdf: {
        label: "Pdf",
        icon: "pi pi-file-pdf",
        type: "pdf",
        ext: "pdf",
      },
      excel: {
        label: "Excel",
        icon: "pi pi-file-excel",
        type: "excel",
        ext: "xlsx",
      },
      csv: {
        label: "Csv",
        icon: "pi pi-table",
        type: "csv",
        ext: "csv",
      },
    },
  };
}
